'use client';

import FamilyCard from './FamilyCard';
import type { ProductFamily } from '@/lib/data/software';

interface FamilyGridProps {
  families: ProductFamily[];
  emptyMessage?: string;
}

export default function FamilyGrid({
  families,
  emptyMessage = 'No products found.',
}: FamilyGridProps) {
  if (families.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {families.map((family) => (
        <FamilyCard key={family.id} family={family} />
      ))}
    </div>
  );
}
